import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import '@/styles/init.css'
import '@/styles/theme.scss'

import 'amfe-flexible'

createApp(App).use(store).use(router).use(ElementPlus).mount('#app')

